import { StyleSheet } from 'react-native';

export const createStyles = () =>
  StyleSheet.create({
    container: { flex: 1 },
    centerContainer: { flex: 1, justifyContent: 'center', alignItems: 'center' },
    scrollContent: { paddingBottom: 40 },

    // Header — compact horizontal layout
    header: {
      paddingHorizontal: 16,
      paddingVertical: 14,
      borderBottomWidth: 1,
    },
    headerTop: {
      flexDirection: 'row',
      alignItems: 'flex-start',
      gap: 14,
      marginBottom: 10,
    },
    avatar: {
      width: 64,
      height: 64,
      borderRadius: 32,
      justifyContent: 'center',
      alignItems: 'center',
    },
    avatarImage: {
      width: 64,
      height: 64,
      borderRadius: 32,
    },
    avatarText: {
      fontSize: 24,
      fontWeight: 'bold',
      color: '#fff',
    },
    headerInfo: {
      flex: 1,
      justifyContent: 'center',
    },
    nameRow: {
      flexDirection: 'row',
      alignItems: 'center',
      gap: 6,
      flexWrap: 'wrap',
      marginBottom: 2,
    },
    userName: {
      fontSize: 18,
      fontWeight: 'bold',
    },
    userEmail: { fontSize: 13 },
    userBio: {
      fontSize: 13,
      marginTop: 4,
    },
    badgesRow: {
      flexDirection: 'row',
      flexWrap: 'wrap',
      gap: 6,
      marginBottom: 10,
    },
    championBadge: {
      paddingHorizontal: 10,
      paddingVertical: 5,
      borderRadius: 12,
      flexDirection: 'row',
      alignItems: 'center',
      gap: 4,
    },
    championBadgeText: {
      fontSize: 12,
      fontWeight: 'bold',
      color: '#8B4513',
    },
    editProfileBtn: {
      marginTop: 10,
      paddingHorizontal: 16,
      paddingVertical: 9,
      borderRadius: 8,
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'center',
      gap: 6,
    },
    editProfileBtnText: {
      fontSize: 14,
      fontWeight: '600',
    },
    socialActions: {
      flexDirection: 'row',
      flexWrap: 'wrap',
      gap: 8,
      marginTop: 10,
    },
    socialButton: {
      paddingHorizontal: 14,
      paddingVertical: 8,
      borderRadius: 8,
      flexDirection: 'row',
      alignItems: 'center',
      gap: 5,
      flex: 1,
      justifyContent: 'center',
    },
    socialButtonText: {
      fontSize: 13,
      fontWeight: '600',
    },

    // Stats section — compact, no icons
    statsSection: {
      flexDirection: 'row',
      paddingHorizontal: 20,
      paddingVertical: 12,
      borderBottomWidth: 1,
    },
    statCard: {
      flex: 1,
      alignItems: 'center',
    },
    statValue: {
      fontSize: 20,
      fontWeight: 'bold',
      marginBottom: 2,
    },
    statLabel: {
      fontSize: 11,
      textTransform: 'uppercase',
      letterSpacing: 0.3,
    },

    // Tabs
    tabsContainer: {
      flexDirection: 'row',
      borderBottomWidth: 1,
    },
    tab: {
      flex: 1,
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'center',
      gap: 5,
      paddingVertical: 10,
      borderBottomWidth: 3,
      borderBottomColor: 'transparent',
    },
    activeTab: {
      borderBottomColor: 'currentColor',
    },
    tabText: { fontSize: 13 },

    // Content sections
    historySection: { padding: 16 },
    sectionTitle: {
      fontSize: 16,
      fontWeight: 'bold',
      marginBottom: 12,
    },
    tournamentItem: {
      padding: 12,
      borderRadius: 10,
      marginBottom: 8,
      borderWidth: 1,
    },
    tournamentHeader: {
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
      marginBottom: 6,
    },
    tournamentNameRow: {
      flexDirection: 'row',
      alignItems: 'center',
      flex: 1,
    },
    tournamentName: {
      fontSize: 15,
      fontWeight: '600',
    },
    statusBadge: {
      paddingHorizontal: 8,
      paddingVertical: 3,
      borderRadius: 8,
    },
    statusText: {
      fontSize: 11,
      fontWeight: '600',
      textTransform: 'capitalize',
    },
    tournamentInfo: {
      flexDirection: 'row',
      justifyContent: 'space-between',
    },
    infoRow: {
      flexDirection: 'row',
      alignItems: 'center',
      gap: 4,
    },
    tournamentType: { fontSize: 13 },
    tournamentDate: { fontSize: 12 },
    emptyContainer: {
      alignItems: 'center',
      paddingVertical: 40,
      gap: 12,
    },
    emptyText: { fontSize: 15 },
    errorText: { fontSize: 16 },

    // Detailed Stats
    detailedStatsCard: {
      borderRadius: 12,
      borderWidth: 1,
      padding: 14,
      marginBottom: 20,
    },
    detailedStatRow: {
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
      paddingVertical: 10,
    },
    detailedStatLabel: { fontSize: 15 },
    detailedStatValue: {
      fontSize: 16,
      fontWeight: '700',
    },
    statDivider: { height: 1 },

    // Posts
    postsSection: {
      flex: 1,
      paddingTop: 8,
    },
    postsList: { paddingBottom: 20 },
    loadingContainer: {
      paddingVertical: 40,
      alignItems: 'center',
    },
    loadingMoreContainer: {
      paddingVertical: 20,
      alignItems: 'center',
    },
  });
